const pushDataLayerObject = dataLayerObject => {
  if (!window.tealium_data2track) {
    window.tealium_data2track = [];
  }

  if (window.utag && window.self === window.top) {
    window.tealium_data2track.push(dataLayerObject);
  } else {
    top.postMessage(dataLayerObject, '*');
  }
};

export const adobeTrackPageView = dataLayerProps => {
  const { id, pageType, pageSection1, pageSection2 } = dataLayerProps;

  const { currentLanguage } = window.locatorTenancy;
  const locale = currentLanguage.split('-');
  const language = locale?.[0]?.toUpperCase();
  const country = locale?.[1]?.toUpperCase();

  const dataLayerObject = {
    id: id,
    Page_Language: language,
    Page_Country: country,
    Page_Type: pageType,
    Page_Section1: pageSection1 || 'Other',
    Page_Section2: pageSection2 || '',
  };

  pushDataLayerObject(dataLayerObject);
};

export const adobeTrackStoreSearch = dataLayerProps => {
  const { isGeolocated, searchKeyword, userZipCode, resultsCount } =
    dataLayerProps;

  const dataLayerObject = {
    id: 'Event',
    Page_Type: 'FindStoreExam',
    Page_Section1: 'Locator',
    Store_Search_Keyword: searchKeyword || '', // user's real query e.g. "new york", "20090"
    Store_Search_Type: isGeolocated ? 'geolocalized' : 'text', // can be "text" (free search) or "geolocalized" (user clicked geolocalize)
    Store_Search_ResultItemsQnt: resultsCount.toString() || '0', // number of returned results/stores e.g. "3", "0"
    Events_FunnelStoreSearch: '1',
  };

  pushDataLayerObject(dataLayerObject);
};

/**
 * Tracks practice card click
 * @param {string} storeName
 */
export const adobeTrackStoreClick = storeName => {
  const dataLayerObject = {
    id: 'VirtualPage-View',
    Page_Type: 'Static',
    Page_Section1: 'Locator',
    Page_Section2: storeName,
  };

  pushDataLayerObject(dataLayerObject);
};

export const adobeTrackOnLoad = () => {
  const dataLayerObject = {
    id: 'Impression',
    Page_Section2: 'FindStore',
  };

  pushDataLayerObject(dataLayerObject);
};

export const adobeTrackCTAClick = e => {
  if (!e) return;

  const dataElementId = e.target.getAttribute('data-element-id');
  const dataDescription = e.target.getAttribute('data-description');

  const dataLayerObject = {
    id: 'Click',
    data_element_id: dataElementId || '',
    data_description: dataDescription || '',
  };

  pushDataLayerObject(dataLayerObject);
};
